"use strict";

function e(e) {
  return e && "object" == typeof e && "default" in e ? e : {
    default: e
  };
}
Object.defineProperty(exports, "__esModule", {
  value: !0
});
var t = e(require("react")),
  r = e => "checkbox" === e.type,
  s = e => e instanceof Date,
  a = e => null == e;
const n = e => "object" == typeof e;
var u = e => !a(e) && !Array.isArray(e) && n(e) && !s(e),
  i = e => u(e) && e.target ? r(e.target) ? e.target.checked : e.target.value : e,
  o = (e, t) => e.has((e => e.substring(0, e.search(/\.\d+(\.|$)/)) || e)(t)),
  l = e => {
    const t = e.constructor && e.constructor.prototype;
    return u(t) && t.hasOwnProperty("isPrototypeOf");
  },
  c = "undefined" != typeof window && void 0 !== window.HTMLElement && "undefined" != typeof document;
function d(e) {
  let t;
  const r = Array.isArray(e);
  if (e instanceof Date) t = new Date(e);else if (e instanceof Set) t = new Set(e);else {
    if (c && (e instanceof Blob || e instanceof FileList) || !r && !u(e)) return e;
    if (t = r ? [] : {}, r || l(e)) for (const r in e) e.hasOwnProperty(r) && (t[r] = d(e[r]));else t = e;
  }
  return t;
}
var f = e => Array.isArray(e) ? e.filter(Boolean) : [],
  m = e => void 0 === e,
  y = (e, t, r) => {
    if (!t || !u(e)) return r;
    const s = f(t.split(/[,[\].]+?/)).reduce((e, t) => a(e) ? e : e[t], e);
    return m(s) || s === e ? m(e[t]) ? r : e[t] : s;
  },
  p = e => "boolean" == typeof e;
const h = {
    BLUR: "blur",
    FOCUS_OUT: "focusout",
    CHANGE: "change"
  },
  g = {
    onBlur: "onBlur",
    onChange: "onChange",
    onSubmit: "onSubmit",
    onTouched: "onTouched",
    all: "all"
  },
  _ = "max",
  v = "min",
  b = "maxLength",
  x = "minLength",
  A = "pattern",
  V = "required",
  S = "validate",
  F = t.default.createContext(null),
  w = () => t.default.useContext(F);
var k = function (e, t, r) {
    let s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
    const a = {
      defaultValues: t._defaultValues
    };
    for (const n in e) Object.defineProperty(a, n, {
      get: () => {
        const a = n;
        return t._proxyFormState[a] !== g.all && (t._proxyFormState[a] = !s || g.all), r && (r[a] = !0), e[a];
      }
    });
    return a;
  },
  D = e => u(e) && !Object.keys(e).length,
  C = (e, t, r, s) => {
    r(e);
    const {
      name: a,
      ...n
    } = e;
    return D(n) || Object.keys(n).length >= Object.keys(t).length || Object.keys(n).find(e => t[e] === (!s || g.all));
  },
  E = e => Array.isArray(e) ? e : [e],
  O = (e, t, r) => !e || !t || e === t || E(e).some(e => e && (r ? e === t : e.startsWith(t) || t.startsWith(e)));
function j(e) {
  const r = t.default.useRef(e);
  r.current = e, t.default.useEffect(() => {
    const t = !e.disabled && r.current.subject && r.current.subject.subscribe({
      next: r.current.next
    });
    return () => {
      t && t.unsubscribe();
    };
  }, [e.disabled]);
}
function T(e) {
  const r = w(),
    {
      control: s = r.control,
      disabled: a,
      name: n,
      exact: u
    } = e || {},
    [i, o] = t.default.useState(s._formState),
    l = t.default.useRef(!0),
    c = t.default.useRef({
      isDirty: !1,
      isLoading: !1,
      dirtyFields: !1,
      touchedFields: !1,
      isValidating: !1,
      isValid: !1,
      errors: !1
    }),
    d = t.default.useRef(n);
  return d.current = n, j({
    disabled: a,
    next: e => l.current && O(d.current, e.name, u) && C(e, c.current, s._updateFormState) && o({
      ...s._formState,
      ...e
    }),
    subject: s._subjects.state
  }), t.default.useEffect(() => (l.current = !0, c.current.isValid && s._updateValid(!0), () => {
    l.current = !1;
  }), [s]), k(i, s, c.current, !1);
}
var U = e => "string" == typeof e,
  B = (e, t, r, s, a) => U(e) ? (s && t.watch.add(e), y(r, e, a)) : Array.isArray(e) ? e.map(e => (s && t.watch.add(e), y(r, e))) : (s && (t.watchAll = !0), r);
function N(e) {
  const r = w(),
    {
      control: s = r.control,
      name: a,
      defaultValue: n,
      disabled: u,
      exact: i
    } = e || {},
    o = t.default.useRef(a);
  o.current = a, j({
    disabled: u,
    subject: s._subjects.values,
    next: e => {
      O(o.current, e.name, i) && c(d(B(o.current, s._names, e.values || s._formValues, !1, n)));
    }
  });
  const [l, c] = t.default.useState(s._getWatch(a, n));
  return t.default.useEffect(() => s._removeUnmounted()), l;
}
var L = e => /^\w*$/.test(e),
  M = e => f(e.replace(/["|']|\]/g, "").split(/\.|\[/));
function R(e, t, r) {
  let s = -1;
  const a = L(t) ? [t] : M(t),
    n = a.length,
    i = n - 1;
  for (; ++s < n;) {
    const t = a[s];
    let n = r;
    if (s !== i) {
      const r = e[t];
      n = u(r) || Array.isArray(r) ? r : isNaN(+a[s + 1]) ? {} : [];
    }
    e[t] = n, e = e[t];
  }
  return e;
}
function P(e) {
  const r = w(),
    {
      name: s,
      disabled: a,
      control: n = r.control,
      shouldUnregister: u
    } = e,
    l = o(n._names.array, s),
    c = N({
      control: n,
      name: s,
      defaultValue: y(n._formValues, s, y(n._defaultValues, s, e.defaultValue)),
      exact: !0
    }),
    f = T({
      control: n,
      name: s
    }),
    g = t.default.useRef(n.register(s, {
      ...e.rules,
      value: c
    }));
  return g.current = n.register(s, e.rules), t.default.useEffect(() => {
    const e = n._options.shouldUnregister || u,
      t = (e, t) => {
        const r = y(n._fields, e);
        r && (r._f.mount = t);
      };
    if (t(s, !0), e) {
      const e = d(y(n._options.defaultValues, s));
      R(n._defaultValues, s, e), m(y(n._formValues, s)) && R(n._formValues, s, e);
    }
    return () => {
      (l ? e && !n._state.action : e) ? n.unregister(s) : t(s, !1);
    };
  }, [s, n, l, u]), t.default.useEffect(() => {
    y(n._fields, s) && n._updateDisabledField({
      disabled: a,
      fields: n._fields,
      name: s
    });
  }, [a, s, n]), {
    field: {
      name: s,
      value: c,
      ...(p(a) ? {
        disabled: a
      } : {}),
      onChange: t.default.useCallback(e => g.current.onChange({
        target: {
          value: i(e),
          name: s
        },
        type: h.CHANGE
      }), [s]),
      onBlur: t.default.useCallback(() => g.current.onBlur({
        target: {
          value: y(n._formValues, s),
          name: s
        },
        type: h.BLUR
      }), [s, n]),
      ref: e => {
        const t = y(n._fields, s);
        t && e && (t._f.ref = {
          focus: () => e.focus(),
          select: () => e.select(),
          setCustomValidity: t => e.setCustomValidity(t),
          reportValidity: () => e.reportValidity()
        });
      }
    },
    formState: f,
    fieldState: Object.defineProperties({}, {
      invalid: {
        enumerable: !0,
        get: () => !!y(f.errors, s)
      },
      isDirty: {
        enumerable: !0,
        get: () => !!y(f.dirtyFields, s)
      },
      isTouched: {
        enumerable: !0,
        get: () => !!y(f.touchedFields, s)
      },
      error: {
        enumerable: !0,
        get: () => y(f.errors, s)
      }
    })
  };
}
const q = "post";
var W = (e, t, r, s, a) => t ? {
  ...r[e],
  types: {
    ...(r[e] && r[e].types ? r[e].types : {}),
    [s]: a || !0
  }
} : {};
const I = (e, t, r) => {
  for (const s of r || Object.keys(e)) {
    const r = y(e, s);
    if (r) {
      const {
        _f: e,
        ...s
      } = r;
      if (e && t(e.name)) {
        if (e.ref.focus) {
          e.ref.focus();
          break;
        }
        if (e.refs && e.refs[0].focus) {
          e.refs[0].focus();
          break;
        }
      } else u(s) && I(s, t);
    }
  }
};
var $ = () => {
    const e = "undefined" == typeof performance ? Date.now() : 1e3 * performance.now();
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, t => {
      const r = (16 * Math.random() + e) % 16 | 0;
      return ("x" == t ? r : 3 & r | 8).toString(16);
    });
  },
  H = function (e, t) {
    let r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return r.shouldFocus || m(r.shouldFocus) ? r.focusName || `${e}.${m(r.focusIndex) ? t : r.focusIndex}.` : "";
  },
  G = e => ({
    isOnSubmit: !e || e === g.onSubmit,
    isOnBlur: e === g.onBlur,
    isOnChange: e === g.onChange,
    isOnAll: e === g.all,
    isOnTouch: e === g.onTouched
  }),
  J = (e, t, r) => !r && (t.watchAll || t.watch.has(e) || [...t.watch].some(t => e.startsWith(t) && /^\.\w+/.test(e.slice(t.length)))),
  z = (e, t, r) => {
    const s = f(y(e, r));
    return R(s, "root", t[r]), R(e, r, s), e;
  },
  K = e => "file" === e.type,
  Q = e => "function" == typeof e,
  X = e => {
    if (!c) return !1;
    const t = e ? e.ownerDocument : 0;
    return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
  },
  Y = e => U(e),
  Z = e => "radio" === e.type,
  ee = e => e instanceof RegExp;
const te = {
    value: !1,
    isValid: !1
  },
  re = {
    value: !0,
    isValid: !0
  };
var se = e => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const t = e.filter(e => e && e.checked && !e.disabled).map(e => e.value);
      return {
        value: t,
        isValid: !!t.length
      };
    }
    return e[0].checked && !e[0].disabled ? e[0].attributes && !m(e[0].attributes.value) ? m(e[0].value) || "" === e[0].value ? re : {
      value: e[0].value,
      isValid: !0
    } : re : te;
  }
  return te;
};
const ae = {
  isValid: !1,
  value: null
};
var ne = e => Array.isArray(e) ? e.reduce((e, t) => t && t.checked && !t.disabled ? {
  isValid: !0,
  value: t.value
} : e, ae) : ae;
function ue(e, t) {
  let r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "validate";
  if (Y(e) || Array.isArray(e) && e.every(Y) || p(e) && !e) return {
    type: r,
    message: Y(e) ? e : "",
    ref: t
  };
}
var ie = e => u(e) && !ee(e) ? e : {
    value: e,
    message: ""
  },
  oe = async (e, t, s, n, i) => {
    const {
        ref: o,
        refs: l,
        required: c,
        maxLength: d,
        minLength: f,
        min: h,
        max: g,
        pattern: F,
        validate: w,
        name: k,
        valueAsNumber: C,
        mount: E,
        disabled: O
      } = e._f,
      j = y(t, k);
    if (!E || O) return {};
    const T = l ? l[0] : o,
      B = e => {
        n && T.reportValidity && (T.setCustomValidity(p(e) ? "" : e || ""), T.reportValidity());
      },
      N = {},
      L = Z(o),
      M = r(o),
      R = L || M,
      P = (C || K(o)) && m(o.value) && m(j) || X(o) && "" === o.value || "" === j || Array.isArray(j) && !j.length,
      q = W.bind(null, k, s, N),
      I = function (e, t, r) {
        let s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : b;
        let a = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : x;
        const n = e ? t : r;
        N[k] = {
          type: e ? s : a,
          message: n,
          ref: o,
          ...q(e ? s : a, n)
        };
      };
    if (i ? !Array.isArray(j) || !j.length : c && (!R && (P || a(j)) || p(j) && !j || M && !se(l).isValid || L && !ne(l).isValid)) {
      const {
        value: e,
        message: t
      } = Y(c) ? {
        value: !!c,
        message: c
      } : ie(c);
      if (e && (N[k] = {
        type: V,
        message: t,
        ref: T,
        ...q(V, t)
      }, !s)) return B(t), N;
    }
    if (!(P || a(h) && a(g))) {
      let e, t;
      const r = ie(g),
        n = ie(h);
      if (a(j) || isNaN(j)) {
        const s = o.valueAsDate || new Date(j),
          a = e => new Date(new Date().toDateString() + " " + e),
          u = "time" == o.type,
          i = "week" == o.type;
        U(r.value) && j && (e = u ? a(j) > a(r.value) : i ? j > r.value : s > new Date(r.value)), U(n.value) && j && (t = u ? a(j) < a(n.value) : i ? j < n.value : s < new Date(n.value));
      } else {
        const s = o.valueAsNumber || (j ? +j : j);
        a(r.value) || (e = s > r.value), a(n.value) || (t = s < n.value);
      }
      if ((e || t) && (I(!!e, r.message, n.message, _, v), !s)) return B(N[k].message), N;
    }
    if ((d || f) && !P && (U(j) || i && Array.isArray(j))) {
      const e = ie(d),
        t = ie(f),
        r = !a(e.value) && j.length > +e.value,
        n = !a(t.value) && j.length < +t.value;
      if ((r || n) && (I(r, e.message, t.message), !s)) return B(N[k].message), N;
    }
    if (F && !P && U(j)) {
      const {
        value: e,
        message: t
      } = ie(F);
      if (ee(e) && !j.match(e) && (N[k] = {
        type: A,
        message: t,
        ref: o,
        ...q(A, t)
      }, !s)) return B(t), N;
    }
    if (w) if (Q(w)) {
      const e = ue(await w(j, t), T);
      if (e && (N[k] = {
        ...e,
        ...q(S, e.message)
      }, !s)) return B(e.message), N;
    } else if (u(w)) {
      let e = {};
      for (const r in w) {
        if (!D(e) && !s) break;
        const a = ue(await w[r](j, t), T, r);
        a && (e = {
          ...a,
          ...q(r, a.message)
        }, B(a.message), s && (N[k] = e));
      }
      if (!D(e) && (N[k] = {
        ref: T,
        ...e
      }, !s)) return N;
    }
    return B(!0), N;
  };
function le(e, t) {
  return [...e, ...E(t)];
}
var ce = e => Array.isArray(e) ? e.map(() => {}) : void 0;
function de(e, t, r) {
  return [...e.slice(0, t), ...E(r), ...e.slice(t)];
}
var fe = (e, t, r) => Array.isArray(e) ? (m(e[r]) && (e[r] = void 0), e.splice(r, 0, e.splice(t, 1)[0]), e) : [];
function me(e, t) {
  return [...E(t), ...E(e)];
}
var ye = (e, t) => m(t) ? [] : function (e, t) {
    let r = 0;
    const s = [...e];
    for (const e of t) s.splice(e - r, 1), r++;
    return f(s).length ? s : [];
  }(e, E(t).sort((e, t) => e - t)),
  pe = (e, t, r) => {
    e[t] = [e[r], e[r] = e[t]][0];
  };
function he(e, t) {
  const r = Array.isArray(t) ? t : L(t) ? [t] : M(t),
    s = 1 === r.length ? e : function (e, t) {
      const r = t.slice(0, -1).length;
      let s = 0;
      for (; s < r;) e = m(e) ? s++ : e[t[s++]];
      return e;
    }(e, r),
    a = r.length - 1,
    n = r[a];
  return s && delete s[n], 0 !== a && (u(s) && D(s) || Array.isArray(s) && function (e) {
    for (const t in e) if (e.hasOwnProperty(t) && !m(e[t])) return !1;
    return !0;
  }(s)) && he(e, r.slice(0, -1)), e;
}
var ge = (e, t, r) => (e[t] = r, e);
function _e() {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: t => {
      for (const r of e) r.next && r.next(t);
    },
    subscribe: t => (e.push(t), {
      unsubscribe: () => {
        e = e.filter(e => e !== t);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}
var ve = e => a(e) || !n(e);
function be(e, t) {
  if (ve(e) || ve(t)) return e === t;
  if (s(e) && s(t)) return e.getTime() === t.getTime();
  const r = Object.keys(e),
    a = Object.keys(t);
  if (r.length !== a.length) return !1;
  for (const n of r) {
    const r = e[n];
    if (!a.includes(n)) return !1;
    if ("ref" !== n) {
      const e = t[n];
      if (s(r) && s(e) || u(r) && u(e) || Array.isArray(r) && Array.isArray(e) ? !be(r, e) : r !== e) return !1;
    }
  }
  return !0;
}
var xe = e => "select-multiple" === e.type,
  Ae = e => Z(e) || r(e),
  Ve = e => X(e) && e.isConnected,
  Se = e => {
    for (const t in e) if (Q(e[t])) return !0;
    return !1;
  };
function Fe(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const r = Array.isArray(e);
  if (u(e) || r) for (const r in e) Array.isArray(e[r]) || u(e[r]) && !Se(e[r]) ? (t[r] = Array.isArray(e[r]) ? [] : {}, Fe(e[r], t[r])) : a(e[r]) || (t[r] = !0);
  return t;
}
function we(e, t, r) {
  const s = Array.isArray(e);
  if (u(e) || s) for (const s in e) Array.isArray(e[s]) || u(e[s]) && !Se(e[s]) ? m(t) || ve(r[s]) ? r[s] = Array.isArray(e[s]) ? Fe(e[s], []) : {
    ...Fe(e[s])
  } : we(e[s], a(t) ? {} : t[s], r[s]) : r[s] = !be(e[s], t[s]);
  return r;
}
var ke = (e, t) => we(e, t, Fe(t)),
  De = (e, _ref) => {
    let {
      valueAsNumber: t,
      valueAsDate: r,
      setValueAs: s
    } = _ref;
    return m(e) ? e : t ? "" === e ? NaN : e ? +e : e : r && U(e) ? new Date(e) : s ? s(e) : e;
  };
function Ce(e) {
  const t = e.ref;
  if (!(e.refs ? e.refs.every(e => e.disabled) : t.disabled)) return K(t) ? t.files : Z(t) ? ne(e.refs).value : xe(t) ? [...t.selectedOptions].map(_ref2 => {
    let {
      value: e
    } = _ref2;
    return e;
  }) : r(t) ? se(e.refs).value : De(m(t.value) ? e.ref.value : t.value, e);
}
var Ee = (e, t, r, s) => {
    const a = {};
    for (const r of e) {
      const e = y(t, r);
      e && R(a, r, e._f);
    }
    return {
      criteriaMode: r,
      names: [...e],
      fields: a,
      shouldUseNativeValidation: s
    };
  },
  Oe = e => m(e) ? e : ee(e) ? e.source : u(e) ? ee(e.value) ? e.value.source : e.value : e,
  je = e => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate);
function Te(e, t, r) {
  const s = y(e, r);
  if (s || L(r)) return {
    error: s,
    name: r
  };
  const a = r.split(".");
  for (; a.length;) {
    const s = a.join("."),
      n = y(t, s),
      u = y(e, s);
    if (n && !Array.isArray(n) && r !== s) return {
      name: r
    };
    if (u && u.type) return {
      name: s,
      error: u
    };
    a.pop();
  }
  return {
    name: r
  };
}
var Ue = (e, t, r, s, a) => !a.isOnAll && (!r && a.isOnTouch ? !(t || e) : (r ? s.isOnBlur : a.isOnBlur) ? !e : !(r ? s.isOnChange : a.isOnChange) || e),
  Be = (e, t) => !f(y(e, t)).length && he(e, t);
const Ne = {
  mode: g.onSubmit,
  reValidateMode: g.onChange,
  shouldFocusError: !0
};
function Le() {
  let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let t = arguments.length > 1 ? arguments[1] : undefined;
  let n,
    l = {
      ...Ne,
      ...e
    },
    _ = {
      submitCount: 0,
      isDirty: !1,
      isLoading: Q(l.defaultValues),
      isValidating: !1,
      isSubmitted: !1,
      isSubmitting: !1,
      isSubmitSuccessful: !1,
      isValid: !1,
      touchedFields: {},
      dirtyFields: {},
      errors: {}
    },
    v = {},
    b = (u(l.defaultValues) || u(l.values)) && d(l.defaultValues || l.values) || {},
    x = l.shouldUnregister ? {} : d(b),
    A = {
      action: !1,
      mount: !1,
      watch: !1
    },
    V = {
      mount: new Set(),
      unMount: new Set(),
      array: new Set(),
      watch: new Set()
    },
    S = 0;
  const F = {
      isDirty: !1,
      dirtyFields: !1,
      touchedFields: !1,
      isValidating: !1,
      isValid: !1,
      errors: !1
    },
    w = {
      values: _e(),
      array: _e(),
      state: _e()
    },
    k = e.resetOptions && e.resetOptions.keepDirtyValues,
    C = G(l.mode),
    O = G(l.reValidateMode),
    j = l.criteriaMode === g.all,
    T = async e => {
      if (F.isValid || e) {
        const e = l.resolver ? D((await q()).errors) : await W(v, !0);
        e !== _.isValid && w.state.next({
          isValid: e
        });
      }
    },
    N = e => F.isValidating && w.state.next({
      isValidating: e
    }),
    L = (e, t, r, s) => {
      const a = y(v, e);
      if (a) {
        const n = y(x, e, m(r) ? y(b, e) : r);
        m(n) || s && s.defaultChecked || t ? R(x, e, t ? n : Ce(a._f)) : Y(e, n), A.mount && T();
      }
    },
    M = (e, t, r, s, a) => {
      let n = !1,
        u = !1;
      const i = {
        name: e
      };
      if (!r || s) {
        F.isDirty && (u = _.isDirty, _.isDirty = i.isDirty = $(), n = u !== i.isDirty);
        const r = be(y(b, e), t);
        u = y(_.dirtyFields, e), r ? he(_.dirtyFields, e) : R(_.dirtyFields, e, !0), i.dirtyFields = _.dirtyFields, n = n || F.dirtyFields && u !== !r;
      }
      if (r) {
        const t = y(_.touchedFields, e);
        t || (R(_.touchedFields, e, r), i.touchedFields = _.touchedFields, n = n || F.touchedFields && t !== r);
      }
      return n && a && w.state.next(i), n ? i : {};
    },
    P = (t, r, s, a) => {
      const u = y(_.errors, t),
        i = F.isValid && p(r) && _.isValid !== r;
      var o;
      if (e.delayError && s ? (o = () => ((e, t) => {
        R(_.errors, e, t), w.state.next({
          errors: _.errors
        });
      })(t, s), n = e => {
        clearTimeout(S), S = setTimeout(o, e);
      }, n(e.delayError)) : (clearTimeout(S), n = null, s ? R(_.errors, t, s) : he(_.errors, t)), (s ? !be(u, s) : u) || !D(a) || i) {
        const e = {
          ...a,
          ...(i && p(r) ? {
            isValid: r
          } : {}),
          errors: _.errors,
          name: t
        };
        _ = {
          ..._,
          ...e
        }, w.state.next(e);
      }
      N(!1);
    },
    q = async e => l.resolver(x, l.context, Ee(e || V.mount, v, l.criteriaMode, l.shouldUseNativeValidation)),
    W = async function (e, t) {
      let r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        valid: !0
      };
      for (const s in e) {
        const a = e[s];
        if (a) {
          const {
            _f: e,
            ...s
          } = a;
          if (e) {
            const s = V.array.has(e.name),
              n = await oe(a, x, j, l.shouldUseNativeValidation && !t, s);
            if (n[e.name] && (r.valid = !1, t)) break;
            !t && (y(n, e.name) ? s ? z(_.errors, n, e.name) : R(_.errors, e.name, n[e.name]) : he(_.errors, e.name));
          }
          s && (await W(s, t, r));
        }
      }
      return r.valid;
    },
    $ = (e, t) => (e && t && R(x, e, t), !be(se(), b)),
    H = (e, t, r) => B(e, V, {
      ...(A.mount ? x : m(t) ? b : U(e) ? {
        [e]: t
      } : t)
    }, r, t),
    Y = function (e, t) {
      let s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      const n = y(v, e);
      let u = t;
      if (n) {
        const s = n._f;
        s && (!s.disabled && R(x, e, De(t, s)), u = X(s.ref) && a(t) ? "" : t, xe(s.ref) ? [...s.ref.options].forEach(e => e.selected = u.includes(e.value)) : s.refs ? r(s.ref) ? s.refs.length > 1 ? s.refs.forEach(e => (!e.defaultChecked || !e.disabled) && (e.checked = Array.isArray(u) ? !!u.find(t => t === e.value) : u === e.value)) : s.refs[0] && (s.refs[0].checked = !!u) : s.refs.forEach(e => e.checked = e.value === u) : K(s.ref) ? s.ref.value = "" : (s.ref.value = u, s.ref.type || w.values.next({
          name: e,
          values: {
            ...x
          }
        })));
      }
      (s.shouldDirty || s.shouldTouch) && M(e, u, s.shouldTouch, s.shouldDirty, !0), s.shouldValidate && re(e);
    },
    Z = (e, t, r) => {
      for (const a in t) {
        const n = t[a],
          u = `${e}.${a}`,
          i = y(v, u);
        !V.array.has(e) && ve(n) && (!i || i._f) || s(n) ? Y(u, n, r) : Z(u, n, r);
      }
    },
    ee = function (e, r) {
      let s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      const n = y(v, e),
        u = V.array.has(e),
        i = d(r);
      R(x, e, i), u ? (w.array.next({
        name: e,
        values: {
          ...x
        }
      }), (F.isDirty || F.dirtyFields) && s.shouldDirty && w.state.next({
        name: e,
        dirtyFields: ke(b, x),
        isDirty: $(e, i)
      })) : !n || n._f || a(i) ? Y(e, i, s) : Z(e, i, s), J(e, V) && w.state.next({
        ..._
      }), w.values.next({
        name: e,
        values: {
          ...x
        }
      }), !A.mount && t();
    },
    te = async e => {
      const t = e.target;
      let r = t.name,
        s = !0;
      const a = y(v, r);
      if (a) {
        let u, o;
        const c = t.type ? Ce(a._f) : i(e),
          d = e.type === h.BLUR || e.type === h.FOCUS_OUT,
          f = !je(a._f) && !l.resolver && !y(_.errors, r) && !a._f.deps || Ue(d, y(_.touchedFields, r), _.isSubmitted, O, C),
          m = J(r, V, d);
        R(x, r, c), d ? (a._f.onBlur && a._f.onBlur(e), n && n(0)) : a._f.onChange && a._f.onChange(e);
        const p = M(r, c, d, !1),
          g = !D(p) || m;
        if (!d && w.values.next({
          name: r,
          type: e.type,
          values: {
            ...x
          }
        }), f) return F.isValid && T(), g && w.state.next({
          name: r,
          ...(m ? {} : p)
        });
        if (!d && m && w.state.next({
          ..._
        }), N(!0), l.resolver) {
          const {
              errors: e
            } = await q([r]),
            t = Te(_.errors, v, r),
            s = Te(e, v, t.name || r);
          u = s.error, r = s.name, o = D(e);
        } else u = (await oe(a, x, j, l.shouldUseNativeValidation))[r], s = Number.isNaN(c) || c === y(x, r, c), s && (u ? o = !1 : F.isValid && (o = await W(v, !0)));
        s && (a._f.deps && re(a._f.deps), P(r, o, u, p));
      }
    },
    re = async function (e) {
      let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      let r, s;
      const a = E(e);
      if (N(!0), l.resolver) {
        const t = await (async e => {
          const {
            errors: t
          } = await q(e);
          if (e) for (const r of e) {
            const e = y(t, r);
            e ? R(_.errors, r, e) : he(_.errors, r);
          } else _.errors = t;
          return t;
        })(m(e) ? e : a);
        r = D(t), s = e ? !a.some(e => y(t, e)) : r;
      } else e ? (s = (await Promise.all(a.map(async e => {
        const t = y(v, e);
        return await W(t && t._f ? {
          [e]: t
        } : t);
      }))).every(Boolean), (s || _.isValid) && T()) : s = r = await W(v);
      return w.state.next({
        ...(!U(e) || F.isValid && r !== _.isValid ? {} : {
          name: e
        }),
        ...(l.resolver || !e ? {
          isValid: r
        } : {}),
        errors: _.errors,
        isValidating: !1
      }), t.shouldFocus && !s && I(v, e => e && y(_.errors, e), e ? a : V.mount), s;
    },
    se = e => {
      const t = {
        ...b,
        ...(A.mount ? x : {})
      };
      return m(e) ? t : U(e) ? y(t, e) : e.map(e => y(t, e));
    },
    ae = (e, t) => ({
      invalid: !!y((t || _).errors, e),
      isDirty: !!y((t || _).dirtyFields, e),
      isTouched: !!y((t || _).touchedFields, e),
      error: y((t || _).errors, e)
    }),
    ne = (e, t, r) => {
      const s = (y(v, e, {
        _f: {}
      })._f || {}).ref;
      R(_.errors, e, {
        ...t,
        ref: s
      }), w.state.next({
        name: e,
        errors: _.errors,
        isValid: !1
      }), r && r.shouldFocus && s && s.focus && s.focus();
    },
    ue = function (e) {
      let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      for (const r of e ? E(e) : V.mount) V.mount.delete(r), V.array.delete(r), t.keepValue || (he(v, r), he(x, r)), !t.keepError && he(_.errors, r), !t.keepDirty && he(_.dirtyFields, r), !t.keepTouched && he(_.touchedFields, r), !l.shouldUnregister && !t.keepDefaultValue && he(b, r);
      w.values.next({
        values: {
          ...x
        }
      }), w.state.next({
        ..._,
        ...(t.keepDirty ? {
          isDirty: $()
        } : {})
      }), !t.keepIsValid && T();
    },
    ie = _ref3 => {
      let {
        disabled: e,
        name: t,
        field: r,
        fields: s
      } = _ref3;
      if (p(e)) {
        const a = e ? void 0 : y(x, t, Ce(r ? r._f : y(s, t)._f));
        R(x, t, a), M(t, a, !1, !1, !0);
      }
    },
    le = function (e) {
      let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      let r = y(v, e);
      const s = p(t.disabled);
      return R(v, e, {
        ...(r || {}),
        _f: {
          ...(r && r._f ? r._f : {
            ref: {
              name: e
            }
          }),
          name: e,
          mount: !0,
          ...t
        }
      }), V.mount.add(e), r ? ie({
        field: r,
        disabled: t.disabled,
        name: e
      }) : L(e, !0, t.value), {
        ...(s ? {
          disabled: t.disabled
        } : {}),
        ...(l.progressive ? {
          required: !!t.required,
          min: Oe(t.min),
          max: Oe(t.max),
          minLength: Oe(t.minLength),
          maxLength: Oe(t.maxLength),
          pattern: Oe(t.pattern)
        } : {}),
        name: e,
        onChange: te,
        onBlur: te,
        ref: s => {
          if (s) {
            le(e, t), r = y(v, e);
            const a = m(s.value) && s.querySelectorAll && s.querySelectorAll("input,select,textarea")[0] || s,
              n = Ae(a),
              u = r._f.refs || [];
            if (n ? u.find(e => e === a) : a === r._f.ref) return;
            R(v, e, {
              _f: {
                ...r._f,
                ...(n ? {
                  refs: [...u.filter(Ve), a, ...(Array.isArray(y(b, e)) ? [{}] : [])],
                  ref: {
                    type: a.type,
                    name: e
                  }
                } : {
                  ref: a
                })
              }
            }), L(e, !1, void 0, a);
          } else r = y(v, e, {}), r._f && (r._f.mount = !1), (l.shouldUnregister || t.shouldUnregister) && (!o(V.array, e) || !A.action) && V.unMount.add(e);
        }
      };
    },
    ce = () => l.shouldFocusError && I(v, e => e && y(_.errors, e), V.mount),
    de = (e, t) => async r => {
      r && (r.preventDefault && r.preventDefault(), r.persist && r.persist());
      let s = d(x);
      if (w.state.next({
        isSubmitting: !0
      }), l.resolver) {
        const {
          errors: e,
          values: t
        } = await q();
        _.errors = e, s = t;
      } else await W(v);
      he(_.errors, "root"), D(_.errors) ? (w.state.next({
        errors: {}
      }), await e(s, r)) : (t && (await t({
        ..._.errors
      }, r)), ce(), setTimeout(ce)), w.state.next({
        isSubmitted: !0,
        isSubmitting: !1,
        isSubmitSuccessful: D(_.errors),
        submitCount: _.submitCount + 1,
        errors: _.errors
      });
    },
    fe = function (r) {
      let s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      const a = r ? d(r) : b,
        n = d(a),
        u = r && !D(r) ? n : b;
      if (s.keepDefaultValues || (b = a), !s.keepValues) {
        if (s.keepDirtyValues || k) for (const e of V.mount) y(_.dirtyFields, e) ? R(u, e, y(x, e)) : ee(e, y(u, e));else {
          if (c && m(r)) for (const e of V.mount) {
            const t = y(v, e);
            if (t && t._f) {
              const e = Array.isArray(t._f.refs) ? t._f.refs[0] : t._f.ref;
              if (X(e)) {
                const t = e.closest("form");
                if (t) {
                  t.reset();
                  break;
                }
              }
            }
          }
          v = {};
        }
        x = e.shouldUnregister ? s.keepDefaultValues ? d(b) : {} : d(u), w.array.next({
          values: {
            ...u
          }
        }), w.values.next({
          values: {
            ...u
          }
        });
      }
      V = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set(),
        watchAll: !1,
        focus: ""
      }, !A.mount && t(), A.mount = !F.isValid || !!s.keepIsValid, A.watch = !!e.shouldUnregister, w.state.next({
        submitCount: s.keepSubmitCount ? _.submitCount : 0,
        isDirty: s.keepDirty ? _.isDirty : !(!s.keepDefaultValues || be(r, b)),
        isSubmitted: !!s.keepIsSubmitted && _.isSubmitted,
        dirtyFields: s.keepDirtyValues ? _.dirtyFields : s.keepDefaultValues && r ? ke(b, r) : {},
        touchedFields: s.keepTouched ? _.touchedFields : {},
        errors: s.keepErrors ? _.errors : {},
        isSubmitSuccessful: !!s.keepIsSubmitSuccessful && _.isSubmitSuccessful,
        isSubmitting: !1
      });
    },
    me = (e, t) => fe(Q(e) ? e(x) : e, t);
  return {
    control: {
      register: le,
      unregister: ue,
      getFieldState: ae,
      handleSubmit: de,
      setError: ne,
      _executeSchema: q,
      _getWatch: H,
      _getDirty: $,
      _updateValid: T,
      _removeUnmounted: () => {
        for (const e of V.unMount) {
          const t = y(v, e);
          t && (t._f.refs ? t._f.refs.every(e => !Ve(e)) : !Ve(t._f.ref)) && ue(e);
        }
        V.unMount = new Set();
      },
      _updateFieldArray: function (e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        let r = arguments.length > 2 ? arguments[2] : undefined;
        let s = arguments.length > 3 ? arguments[3] : undefined;
        let a = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !0;
        let n = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !0;
        if (s && r) {
          if (A.action = !0, n && Array.isArray(y(v, e))) {
            const t = r(y(v, e), s.argA, s.argB);
            a && R(v, e, t);
          }
          if (n && Array.isArray(y(_.errors, e))) {
            const t = r(y(_.errors, e), s.argA, s.argB);
            a && R(_.errors, e, t), Be(_.errors, e);
          }
          if (F.touchedFields && n && Array.isArray(y(_.touchedFields, e))) {
            const t = r(y(_.touchedFields, e), s.argA, s.argB);
            a && R(_.touchedFields, e, t);
          }
          F.dirtyFields && (_.dirtyFields = ke(b, x)), w.state.next({
            name: e,
            isDirty: $(e, t),
            dirtyFields: _.dirtyFields,
            errors: _.errors,
            isValid: _.isValid
          });
        } else R(x, e, t);
      },
      _updateDisabledField: ie,
      _getFieldArray: t => f(y(A.mount ? x : b, t, e.shouldUnregister ? y(b, t, []) : [])),
      _reset: fe,
      _resetDefaultValues: () => Q(l.defaultValues) && l.defaultValues().then(e => {
        me(e, l.resetOptions), w.state.next({
          isLoading: !1
        });
      }),
      _updateFormState: e => {
        _ = {
          ..._,
          ...e
        };
      },
      _subjects: w,
      _proxyFormState: F,
      get _fields() {
        return v;
      },
      get _formValues() {
        return x;
      },
      get _state() {
        return A;
      },
      set _state(e) {
        A = e;
      },
      get _defaultValues() {
        return b;
      },
      get _names() {
        return V;
      },
      set _names(e) {
        V = e;
      },
      get _formState() {
        return _;
      },
      set _formState(e) {
        _ = e;
      },
      get _options() {
        return l;
      },
      set _options(e) {
        l = {
          ...l,
          ...e
        };
      }
    },
    trigger: re,
    register: le,
    handleSubmit: de,
    watch: (e, t) => Q(e) ? w.values.subscribe({
      next: r => e(H(void 0, t), r)
    }) : H(e, t, !0),
    setValue: ee,
    getValues: se,
    reset: me,
    resetField: function (e) {
      let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      y(v, e) && (m(t.defaultValue) ? ee(e, y(b, e)) : (ee(e, t.defaultValue), R(b, e, t.defaultValue)), t.keepTouched || he(_.touchedFields, e), t.keepDirty || (he(_.dirtyFields, e), _.isDirty = t.defaultValue ? $(e, y(b, e)) : $()), t.keepError || (he(_.errors, e), F.isValid && T()), w.state.next({
        ..._
      }));
    },
    clearErrors: e => {
      e && E(e).forEach(e => he(_.errors, e)), w.state.next({
        errors: e ? _.errors : {}
      });
    },
    unregister: ue,
    setError: ne,
    setFocus: function (e) {
      let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      const r = y(v, e),
        s = r && r._f;
      if (s) {
        const e = s.refs ? s.refs[0] : s.ref;
        e.focus && (e.focus(), t.shouldSelect && e.select());
      }
    },
    getFieldState: ae
  };
}
exports.Controller = e => e.render(P(e)), exports.Form = function (e) {
  const r = w(),
    [s, a] = t.default.useState(!1),
    {
      control: n = r.control,
      onSubmit: u,
      children: i,
      action: o,
      method: l = q,
      headers: c,
      encType: d,
      onError: f,
      render: m,
      onSuccess: p,
      validateStatus: h,
      ...g
    } = e,
    _ = async t => {
      let r = !1,
        s = "";
      await n.handleSubmit(async e => {
        const a = new FormData();
        let i = "";
        try {
          i = JSON.stringify(e);
        } catch (e) {}
        for (const t of n._names.mount) a.append(t, y(e, t));
        if (u && (await u({
          data: e,
          event: t,
          method: l,
          formData: a,
          formDataJson: i
        })), o) try {
          const e = [c && c["Content-Type"], d].some(e => e && e.includes("json")),
            t = await fetch(o, {
              method: l,
              headers: {
                ...c,
                ...(d ? {
                  "Content-Type": d
                } : {})
              },
              body: e ? i : a
            });
          t && (h ? !h(t.status) : t.status < 200 || t.status >= 300) ? (r = !0, f && f({
            response: t
          }), s = String(t.status)) : p && p({
            response: t
          });
        } catch (e) {
          r = !0, f && f({
            error: e
          });
        }
      })(t), r && e.control && (e.control._subjects.state.next({
        isSubmitSuccessful: !1
      }), e.control.setError("root.server", {
        type: s
      }));
    };
  return t.default.useEffect(() => {
    a(!0);
  }, []), m ? t.default.createElement(t.default.Fragment, null, m({
    submit: _
  })) : t.default.createElement("form", {
    noValidate: s,
    action: o,
    method: l,
    encType: d,
    onSubmit: _,
    ...g
  }, i);
}, exports.FormProvider = e => {
  const {
    children: r,
    ...s
  } = e;
  return t.default.createElement(F.Provider, {
    value: s
  }, r);
}, exports.appendErrors = W, exports.get = y, exports.set = R, exports.useController = P, exports.useFieldArray = function (e) {
  const r = w(),
    {
      control: s = r.control,
      name: a,
      keyName: n = "id",
      shouldUnregister: u
    } = e,
    [i, o] = t.default.useState(s._getFieldArray(a)),
    l = t.default.useRef(s._getFieldArray(a).map($)),
    c = t.default.useRef(i),
    f = t.default.useRef(a),
    m = t.default.useRef(!1);
  f.current = a, c.current = i, s._names.array.add(a), e.rules && s.register(a, e.rules), j({
    next: _ref4 => {
      let {
        values: e,
        name: t
      } = _ref4;
      if (t === f.current || !t) {
        const t = y(e, f.current);
        Array.isArray(t) && (o(t), l.current = t.map($));
      }
    },
    subject: s._subjects.array
  });
  const p = t.default.useCallback(e => {
    m.current = !0, s._updateFieldArray(a, e);
  }, [s, a]);
  return t.default.useEffect(() => {
    if (s._state.action = !1, J(a, s._names) && s._subjects.state.next({
      ...s._formState
    }), m.current && (!G(s._options.mode).isOnSubmit || s._formState.isSubmitted)) if (s._options.resolver) s._executeSchema([a]).then(e => {
      const t = y(e.errors, a),
        r = y(s._formState.errors, a);
      (r ? !t && r.type || t && (r.type !== t.type || r.message !== t.message) : t && t.type) && (t ? R(s._formState.errors, a, t) : he(s._formState.errors, a), s._subjects.state.next({
        errors: s._formState.errors
      }));
    });else {
      const e = y(s._fields, a);
      e && e._f && oe(e, s._formValues, s._options.criteriaMode === g.all, s._options.shouldUseNativeValidation, !0).then(e => !D(e) && s._subjects.state.next({
        errors: z(s._formState.errors, e, a)
      }));
    }
    s._subjects.values.next({
      name: a,
      values: {
        ...s._formValues
      }
    }), s._names.focus && I(s._fields, e => !!e && e.startsWith(s._names.focus || "")), s._names.focus = "", s._updateValid(), m.current = !1;
  }, [i, a, s]), t.default.useEffect(() => (!y(s._formValues, a) && s._updateFieldArray(a), () => {
    (s._options.shouldUnregister || u) && s.unregister(a);
  }), [a, s, n, u]), {
    swap: t.default.useCallback((e, t) => {
      const r = s._getFieldArray(a);
      pe(r, e, t), pe(l.current, e, t), p(r), o(r), s._updateFieldArray(a, r, pe, {
        argA: e,
        argB: t
      }, !1);
    }, [p, a, s]),
    move: t.default.useCallback((e, t) => {
      const r = s._getFieldArray(a);
      fe(r, e, t), fe(l.current, e, t), p(r), o(r), s._updateFieldArray(a, r, fe, {
        argA: e,
        argB: t
      }, !1);
    }, [p, a, s]),
    prepend: t.default.useCallback((e, t) => {
      const r = E(d(e)),
        n = me(s._getFieldArray(a), r);
      s._names.focus = H(a, 0, t), l.current = me(l.current, r.map($)), p(n), o(n), s._updateFieldArray(a, n, me, {
        argA: ce(e)
      });
    }, [p, a, s]),
    append: t.default.useCallback((e, t) => {
      const r = E(d(e)),
        n = le(s._getFieldArray(a), r);
      s._names.focus = H(a, n.length - 1, t), l.current = le(l.current, r.map($)), p(n), o(n), s._updateFieldArray(a, n, le, {
        argA: ce(e)
      });
    }, [p, a, s]),
    remove: t.default.useCallback(e => {
      const t = ye(s._getFieldArray(a), e);
      l.current = ye(l.current, e), p(t), o(t), s._updateFieldArray(a, t, ye, {
        argA: e
      });
    }, [p, a, s]),
    insert: t.default.useCallback((e, t, r) => {
      const n = E(d(t)),
        u = de(s._getFieldArray(a), e, n);
      s._names.focus = H(a, e, r), l.current = de(l.current, e, n.map($)), p(u), o(u), s._updateFieldArray(a, u, de, {
        argA: e,
        argB: ce(t)
      });
    }, [p, a, s]),
    update: t.default.useCallback((e, t) => {
      const r = d(t),
        n = ge(s._getFieldArray(a), e, r);
      l.current = [...n].map((t, r) => t && r !== e ? l.current[r] : $()), p(n), o([...n]), s._updateFieldArray(a, n, ge, {
        argA: e,
        argB: r
      }, !0, !1);
    }, [p, a, s]),
    replace: t.default.useCallback(e => {
      const t = E(d(e));
      l.current = t.map($), p([...t]), o([...t]), s._updateFieldArray(a, [...t], e => e, {}, !0, !1);
    }, [p, a, s]),
    fields: t.default.useMemo(() => i.map((e, t) => ({
      ...e,
      [n]: l.current[t] || $()
    })), [i, n])
  };
}, exports.useForm = function () {
  let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const r = t.default.useRef(),
    s = t.default.useRef(),
    [a, n] = t.default.useState({
      isDirty: !1,
      isValidating: !1,
      isLoading: Q(e.defaultValues),
      isSubmitted: !1,
      isSubmitting: !1,
      isSubmitSuccessful: !1,
      isValid: !1,
      submitCount: 0,
      dirtyFields: {},
      touchedFields: {},
      errors: {},
      defaultValues: Q(e.defaultValues) ? void 0 : e.defaultValues
    });
  r.current || (r.current = {
    ...Le(e, () => n(e => ({
      ...e
    }))),
    formState: a
  });
  const u = r.current.control;
  return u._options = e, j({
    subject: u._subjects.state,
    next: e => {
      C(e, u._proxyFormState, u._updateFormState, !0) && n({
        ...u._formState
      });
    }
  }), t.default.useEffect(() => {
    e.values && !be(e.values, s.current) ? (u._reset(e.values, u._options.resetOptions), s.current = e.values) : u._resetDefaultValues();
  }, [e.values, u]), t.default.useEffect(() => {
    u._state.mount || (u._updateValid(), u._state.mount = !0), u._state.watch && (u._state.watch = !1, u._subjects.state.next({
      ...u._formState
    })), u._removeUnmounted();
  }), r.current.formState = k(a, u), r.current;
}, exports.useFormContext = w, exports.useFormState = T, exports.useWatch = N;